import React, { useEffect } from 'react';
import { Card, Form } from 'antd';
import Layout from './layout';
import dataTransform from '../../../util/dataTransform';
import StudentFormItem from './StudentFormItem';
import EnrollCourseFormItem from './EnrollCourseFormItem';
import InputFormItem from './InputFormItem';
import ShowUserDetail from './ShowUserDetail';
import SubmitFormItem from './SubmitFormItem';
import DateFormItem from './DateFormItem';
import FormSteps from './FormSteps';

function handleSubmit(form, postEnrollTransaction, history) {
  const rawData = form.getFieldValue();
  const transactionData = dataTransform.transactionDataTransform(rawData);
  postEnrollTransaction(transactionData, history);
}

const Transaction = (props) => {
  const [form] = Form.useForm();

  const {
    history,
    fetchStudentList,
    studentList,
    fetchEnrollCourseList,
    enrollCourseList,
    userList,
    fetchUserList,
    postEnrollTransaction,
    fetchEnrollCourseDetail,
    enrollCourseDetail,
    searchDetail,
  } = props;

  useEffect(() => {
    return () => {
      searchDetail({});
    };
  }, []);

  useEffect(() => {
    if (fetchUserList) {
      fetchUserList();
    }
  }, [fetchUserList]);

  useEffect(() => {
    if (form.getFieldValue('receiver')) {
      return;
    }
    const admin = (userList || []).find((item) => item.name === 'admin');
    if (admin) {
      form.setFieldsValue({ receiver: admin._id });
    }
  }, [form, userList]);

  return (
    <div>
      <FormSteps currentStep={2} />
      <Card title='请登记学生转账的信息' style={Layout.cardStyle}>
        <Form form={form}>
          <StudentFormItem
            rules={[]}
            form={form}
            fetchStudentList={fetchStudentList}
            studentList={studentList}
            itemStyle={Layout.filterInputStyle}
          />
          <EnrollCourseFormItem
            fetchEnrollCourseList={fetchEnrollCourseList}
            fetchEnrollCourseDetail={fetchEnrollCourseDetail}
            enrollCourseList={enrollCourseList}
            form={form}
          />
          <ShowUserDetail
            label='学生余款'
            displayDetail={enrollCourseDetail}
            displayData='balance'
            prefix='AUD'
          />
          <ShowUserDetail
            label='试听课老师'
            displayDetail={enrollCourseDetail}
            displayData='trialTeacher'
          />
          <ShowUserDetail
            label='推荐人'
            displayDetail={enrollCourseDetail}
            displayData='advisor'
          />
          <InputFormItem
            label='总计澳币金额'
            fieldName='total_aud'
            placeholder='请输入支付折算成澳币的金额'
            requireMessage='总计澳币金额不能为空'
          />
          <Form.Item name='receiver' hidden>
            <input type='hidden' />
          </Form.Item>
          <DateFormItem form={form} />
          <InputFormItem
            label='备注'
            fieldName='comments'
            placeholder='请输入备注'
          />
          <SubmitFormItem
            hasModel={false}
            handleClick={() =>
              handleSubmit(form, postEnrollTransaction, history)
            }
          />
        </Form>
      </Card>
    </div>
  );
};

export default Transaction;
